<template lang="html">

  <footer>


    <div class="container">

      <div class="footer-container row-start ais">

        <article class="first">
          <router-link to="" class="link-to-home">
            <img width="85" src="/static/img/logo-iner-blanco.svg" alt="Logo iner">
          </router-link>
          <div class="contacts-container">
            <a href="tel:900848402" class="phone-icon">900 848 402</a>
            <a href="mailto:iner@inerenergia.es" class="mail-icon">iner@inerenergia.es</a>
            <rrss></rrss>
          </div>
          <a target="_blank" rel="noopener" href="https://clientes.inerenergia.es/login" class="btn -degree">Zona clientes</a>
        </article>

        <article class="links-container">
          <h4>Somos iner</h4>
          <router-link :to="$t('enlaces.asi_somos')">Así somos</router-link>
          <router-link :to="$t('enlaces.que_ofrecemos')">Qué Ofrecemos</router-link>
          <router-link :to="$t('enlaces.blog')">Blog</router-link>
          <router-link :to="$t('enlaces.promociones')">Promociones</router-link>
          
          <router-link :to="$t('enlaces.contacto')">Contacto</router-link>
        </article>

        <article class="links-container">
          <h4>Tarifas</h4>
          <router-link :to="$t('enlaces.tarifas_luz')">Tarifas de Luz</router-link>
          <router-link :to="$t('enlaces.tarifas_gas')">Tarifas de Gas</router-link>
          <router-link :to="$t('enlaces.tarifas_luzgas')">Tarifas de Luz y Gas</router-link>
          <router-link :to="$t('enlaces.ofrecemosMuchoMas')">Otros servicios</router-link>
          <router-link :to="$t('enlaces.simulador')">Simulador de Ahorro</router-link>
          <router-link :to="$t('enlaces.contacto')" title="Contrata">Inergízate</router-link>
        </article>

        <article class="links-container -big">
          <h4>Resuelve tus dudas</h4>
          <router-link :to="$t('enlaces.preguntas_frecuentes')">Preguntas frecuentes</router-link>
          <h4>Empresa</h4>
          <router-link :to="$t('enlaces.empresas')">Soy empresa</router-link>
        </article>

        <article class="links-container">
          <h4>Legal</h4>
          <router-link :to="$t('enlaces.politica_privacidad')">Política de privacidad</router-link>
          <router-link :to="$t('enlaces.aviso_legal')">Aviso legal</router-link>
          <router-link :to="$t('enlaces.politica_cookies')">Política de cookies</router-link>
          <router-link :to="$t('enlaces.terminos_y_condiciones')">Términos y condiciones</router-link>

        </article>

        <p class="rights">2022© Iner Energia</p>

        <a rel="noopener" target="_blank" href="https://clientes.inerenergia.es/login" class="btn -mvl -degree">Zona clientes</a>

      </div>

    </div>

  </footer>

</template>

<script lang="js">


  import rrss from '@/components/parts/rrss';

  export default  {
    name: 'app-footer',
    components :{
      'rrss' : rrss
    }

  }

</script>

<style scoped lang="scss">

  @import '@/assets/css/colors.scss';

  footer {
    background: $dark;
    color: white;
    width: 100%;
    display: inline-block;
    padding: 40px 0;
    position: relative;
  }
  
  .footer-container{
    position: relative;
    max-width: 960px;
  }

  .btn.-mvl{
    display: none;
  }

  article{
    max-width: 160px;
    padding: 0 10px;
    padding-top: 10px;
    width: 100%;

    &.-big{
      max-width: 220px;
    }

    &.first{
      max-width: 250px;
      width: 100%;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
      -ms-align-items: center;
      align-items: center;
      justify-content: flex-start;
      -webkit-justify-content: flex-start;
      -webkit-flex-direction: column;
      -moz-flex-direction: column;
      -ms-flex-direction: column;
      -o-flex-direction: column;
      flex-direction: column;
    }

    .contacts-container{
      max-width: 140px;
    }


    h4{
      text-align: left;
      font-size: 16px;
      font-weight: 800; 
      text-transform: uppercase;
      color: white;
    }

    a + h4{
      margin-top: 25px;
    }

    a:not(.btn){
      font-size: 12px;
      line-height: 22px;
      height: 22px;
      width: 100%;
      display: inline-block;
      text-align: left;
      color: white;
    }

    a.link-to-home{
      width: 127px;
      text-align: center;
      margin-bottom: 10px;
      height: auto;
      color: white;
      padding-left: 10px,;
    }

    a.phone-icon{
      padding-left: 35px;
      background: url("/static/img/telefono-icon.svg") 4px center/auto 22px no-repeat;
      min-height: 30px;
      line-height: 30px;
      width: auto;
      color: white;
      min-width: 137px;
    }

    a.mail-icon{
      padding-left: 35px;
      background: url("/static/img/mail-icon.svg") center left/auto 17px no-repeat;
      min-height: 30px;
      line-height: 30px;
      width: auto;
      color: white;
      min-width: 137px;
    }


  }
  
  .rights{
    color: $orange;
    position: absolute;
    right: 0;
    bottom: 0;
    font-size: 12px;
  }

  .btn{
    border:1px solid $dark;
  }

  .btn:hover{
    border-color:$orange;
  }


  @media screen and (max-width: 1100px){
    .rights{
      padding-right: 120px;
    }
  }


  @media screen and (max-width: 990px){

    article{
      max-width: 140px;
    }

    article.first{
      max-width: 220px;
    }

    article.-big{
      max-width: 190px;
    }

    .rights{
      padding-right: 150px;
    }

  }

  @media screen and (max-width: 870px){


    .footer-container{
      justify-content: space-between;
      padding-bottom: 50px;
    }

    article.first{
      width: 100%;
      max-width: 100%;
      order: -1;
      -webkit-flex-direction: row;
      -moz-flex-direction: row;
      -ms-flex-direction: row;
      -o-flex-direction: row;
      flex-direction: row;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      -ms-align-items: center;
      align-items: center;

      padding-top: 0;
      margin-bottom: 10px;

      .contacts-container{
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: flex;
        justify-content: flex-end;
        -webkit-justify-content: flex-end;
        -ms-align-items: center;
        align-items: center;
        max-width: 50%;
      }

      a.link-to-home{
        margin-bottom: 0;
        padding-left: 0;
        text-align: left;
      }
      
      .btn{
        display: none;
      }


    }

    article{
      width:auto;
      display: block;
    }

    .btn.-mvl{
      display: inline-block;
      position: absolute;
      left: 0;
      bottom: 0;
    }

    .rights{
      width: 100%;
      text-align: right;
      padding-right: 0;
      height: 40px;
      line-height: 40px;
    }

  }


  @media screen and (max-width: 560px){

    article{
      padding: 0;
    }

    article.first a.link-to-home{
      width: 100%;
      height: 40px;
      line-height: 40px;
    }
    
    .btn.-mvl{
      position: absolute;
      right: 0;
      top: 0;
      left: auto;
      height: 35px;
      line-height: 35px;
      font-size: 12px;
    }

    article.first{
      -webkit-flex-direction: column;
      -moz-flex-direction: column;
      -ms-flex-direction: column;
      -o-flex-direction: column;
      flex-direction: column;
    }

    article.first .contacts-container{
      max-width: 100%;
      margin-top: 10px;
      width: 100%;
      justify-content: space-between;
      -webkit-justify-content: space-between;
    }

    article a.phone-icon{
      padding-left: 30px;
      min-width: 0;
    }

    article a.mail-icon{
      min-width: 0;
    }

    .rights{
      text-align: center;
    }

    article{
      width: 50%;
      margin-bottom: 20px;
    }

    article a + h4{
      margin-top: 10px;
    }

  }

  @media screen and (max-width: 400px){
    article a.phone-icon{
      background-size: 14px;
      padding-left: 23px;
    }

    article a.mail-icon{
      background-size: 20px;
      padding-left: 25px;
    }

    footer{
      padding-bottom: 20px;
    }

    .footer-container{
      padding-bottom: 30px;
    }
  }

  @media screen and (max-width: 350px){
    article a.phone-icon{
      background: none;
      padding-left: 0;
    }

    article a.mail-icon{
      padding-left: 0;
      background: none;
    }
  }
  

</style>



// WEBPACK FOOTER //
// src/components/parts/footer.vue